import { baseApi } from "./base.api";

export const blogsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBlogs: build.query({
      query: (params) => ({ url: "/blogs/fetch", method: "GET", params }),
      providesTags: ["Blog"],
    }),
    fetchBlogsAll: build.query({
      query: () => ({ url: "/blogs/fetch/all", method: "GET" }),
      providesTags: ["Blog"],
    }),
    fetchTrashedBlogs: build.query({
      query: (params) => ({ url: "/blogs/fetch/trashed", method: "GET", params }),
      providesTags: ["Blog"],
    }),
    fetchBlogById: build.query({
      query: (id) => ({ url: `/blogs/fetch/${id}`, method: "GET" }),
      providesTags: ["Blog"],
    }),
    createBlog: build.mutation({
      query: (body) => ({ url: "/blogs/create", method: "POST", body }),
      invalidatesTags: ["Blog"],
    }),
    updateBlog: build.mutation({
      query: ({ id, body }) => ({ url: `/blogs/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Blog"],
    }),
    changeBlogStatus: build.mutation({
      query: (id) => ({ url: `/blogs/status/${id}`, method: "PUT" }),
      invalidatesTags: ["Blog"],
    }),
    restoreBlog: build.mutation({
      query: (id) => ({ url: `/blogs/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Blog"],
    }),
    bulkRestoreBlogs: build.mutation({
      query: (body) => ({ url: "/blogs/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Blog"],
    }),
    deleteBlog: build.mutation({
      query: (id) => ({ url: `/blogs/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Blog"],
    }),
    bulkDeleteBlogs: build.mutation({
      query: (body) => ({ url: "/blogs/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Blog"],
    }),
    destroyBlog: build.mutation({
      query: (id) => ({ url: `/blogs/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Blog"],
    }),
    bulkDestroyBlogs: build.mutation({
      query: (body) => ({ url: "/blogs/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Blog"],
    }),
  }),
});

export const {
  useFetchBlogsQuery,
  useFetchBlogsAllQuery,
  useFetchTrashedBlogsQuery,
  useFetchBlogByIdQuery,
  useCreateBlogMutation,
  useUpdateBlogMutation,
  useChangeBlogStatusMutation,
  useRestoreBlogMutation,
  useBulkRestoreBlogsMutation,
  useDeleteBlogMutation,
  useBulkDeleteBlogsMutation,
  useDestroyBlogMutation,
  useBulkDestroyBlogsMutation,
} = blogsApi;
